import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { Media, MediaBody, MediaLeft } from 'foundations-components/transitional/components/Media';
import VariantInfo from 'personalization-lib/components/shared/display/VariantInfo';
import AssetThumbnail from 'personalization-lib/components/thumbnail/AssetThumbnail';
import { getAssetEditorUrl } from 'personalization-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantsModalRow = ({
  segmentIdentifier,
  assetCoordinates,
  assetData,
  loading,
  error
}) => /*#__PURE__*/_jsx("tr", {
  children: /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsxs(Media, {
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(AssetThumbnail, {
          imgSrc: assetData === null || assetData === void 0 ? void 0 : assetData.imgSrc,
          inlineSize: "65px",
          maxBlockSize: "40px"
        })
      }), /*#__PURE__*/_jsx(MediaBody, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "100",
          children: [/*#__PURE__*/_jsx(Link, {
            target: "_blank",
            href: getAssetEditorUrl(assetCoordinates),
            truncate: true,
            maxInlineSize: "340px",
            children: assetData === null || assetData === void 0 ? void 0 : assetData.name
          }), /*#__PURE__*/_jsx(VariantInfo, {
            segmentIdentifier: segmentIdentifier,
            publishStatus: assetData === null || assetData === void 0 ? void 0 : assetData.publishStatus,
            targetingState: assetData === null || assetData === void 0 ? void 0 : assetData.targetingState,
            loading: loading,
            error: error
          })]
        })
      })]
    })
  })
});
export default VariantsModalRow;